import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SopoAlertComponent } from './components/sopo-alert/sopo-alert.component';
import { SopoConfirmComponent } from './components/sopo-confirm/sopo-confirm.component';
import { SopoDialogComponent } from './components/sopo-dialog/sopo-dialog.component';
import { IonicModule } from '@ionic/angular';
import { SopoStringInputComponent } from './components/sopo-string-input/sopo-string-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SopoNumberInputComponent } from './components/sopo-number-input/sopo-number-input.component';
import { SopoDoubleInputComponent } from './components/sopo-double-input/sopo-double-input.component';
import { PhoneNumberInputComponent } from '../shared/services/dialog-input/components/phone-number-input/phone-number-input.component';
import { NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input';
import { SopoMultiDaySettingsInputComponent } from './components/sopo-multi-day-settings-input/sopo-multi-day-settings-input.component';
import { SopoSelectListComponent } from './components/sopo-select-list/sopo-select-list.component';
import { SopoPhoneNumberInputComponent } from './components/sopo-phone-number-input/sopo-phone-number-input.component';
import { SopoTreeButtonConfirmComponent } from './components/sopo-tree-button-confirm/sopo-tree-button-confirm.component';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SopoVerifyInfoPopupComponent } from './components/sopo-verify-info/sopo-verify-info.component';
import { SopoVerifyAdditionalInfoComponent } from './components/sopo-verify-additional-info/sopo-verify-additional-info.component';
import { SopoDepositFeeComponent } from './components/sopo-deposit-fee/sopo-deposit-fee.component';
import { SopoCoinflowShopComponent } from './components/sopo-coinflow-shop/sopo-coinflow-shop.component';
import { SopoClubJoinConfirmComponent } from './components/sopo-club-join-confirm/sopo-club-join-confirm.component';
import { SopoConfirmCryptoWithdrawComponent } from './components/sopo-confirm-crypto-withdraw/sopo-confirm-crypto-withdraw.component';
import { SopoDisableSideBettingComponent } from './components/sopo-disable-side-betting/sopo-disable-side-betting.component';
import { SopoSideBettingComponent } from './components/sopo-side-betting/sopo-side-betting.component';
import { SopoSideBettingSuccessComponent } from './components/sopo-side-betting-success/sopo-side-betting-success.component';
import { SharedPipesModule } from '../shared/pipes/shared.pipes.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaterialIntlTelInputComponent,
        SharedComponentsModule,
        SharedPipesModule,
    ],
    declarations: [
        SopoAlertComponent,
        SopoConfirmComponent,
        SopoClubJoinConfirmComponent,
        SopoDialogComponent,
        SopoStringInputComponent,
        SopoNumberInputComponent,
        SopoDoubleInputComponent,
        PhoneNumberInputComponent,
        SopoMultiDaySettingsInputComponent,
        SopoSelectListComponent,
        SopoPhoneNumberInputComponent,
        SopoTreeButtonConfirmComponent,
        SopoVerifyInfoPopupComponent,
        SopoVerifyAdditionalInfoComponent,
        SopoDepositFeeComponent,
        SopoCoinflowShopComponent,
        SopoConfirmCryptoWithdrawComponent,
        SopoDisableSideBettingComponent,
        SopoSideBettingComponent,
        SopoSideBettingSuccessComponent,
    ],
})
export class SopoPopupModule {}
